import { useState } from 'react'
import {
  Container,
  Typography,
  Box,
  Paper,
  Stack,
  Tabs,
  Tab
} from '@mui/material'
import KitchenIcon from '@mui/icons-material/Kitchen'
import CatalogTab from './CatalogTab'
import CollectionsTab from './CollectionsTab'

type TabKey = 'all' | 'collections'

const ProductsPage = () => {
  const [tab, setTab] = useState<TabKey>('all')

  return (
    <Container maxWidth='xl' sx={{ py: 4 }}>
      <Paper elevation={3} sx={{ overflow: 'hidden' }}>
        <Box sx={{ px: 3, pt: 3 }}>
          <Stack direction='row' alignItems='center' spacing={2} sx={{ mb: 2 }}>
            <KitchenIcon fontSize='large' color='primary' />
            <Typography variant='h4'>Products</Typography>
          </Stack>
        </Box>

        <Tabs
          value={tab}
          onChange={(_, v) => setTab(v as TabKey)}
          sx={{
            px: 3,
            borderBottom: 1,
            borderColor: 'divider',
            '& .MuiTab-root': { textTransform: 'none' }
          }}
        >
          <Tab value='all' label='All Products' />
          <Tab value='collections' label='Collections' />
        </Tabs>

        <Box sx={{ p: 3 }}>
          {tab === 'all' ? <CatalogTab /> : <CollectionsTab />}
        </Box>
      </Paper>
    </Container>
  )
}

export default ProductsPage
